// Radha — Japanese (ja-JP) locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const ja = {
  "nav.overview": "概要",
  "nav.collections": "債権回収",
  "nav.disputes": "係争",
  "nav.contracts": "契約",
  "nav.invoicing": "請求",
  "nav.recurring": "定期請求",
  "nav.statements": "取引明細",
  "nav.creditNotes": "クレジットノート",
  "nav.gst": "税務",
  "nav.tax": "税務・電子インボイス",
  "nav.reconciliation": "消込",
  "nav.deductions": "控除",
  "nav.withholding": "源泉徴収",
  "nav.cashflow": "キャッシュフロー",
  "nav.crm": "CRM",
  "nav.forecasts": "予測",
  "nav.reminders": "リマインダー",
  "nav.dunning": "督促",
  "nav.automation": "自動化",
  "nav.settings": "設定",
  "nav.privacy": "プライバシー",
  "group.receivables": "売掛金",
  "group.planning": "計画",
  "group.operations": "オペレーション",
  "group.admin": "管理",
  "app.tagline": "Revenue Operating System",
  "app.signOut": "サインアウト",
  "app.search": "検索",
  "app.toggleTheme": "配色を切り替え",
  "app.toggleNav": "ナビゲーションを切り替え",
  "app.language": "言語",
  "app.useTenantDefault": "テナントの既定を使用",
  "state.loading": "読み込み中…",
  "state.error": "データを読み込めませんでした",
  "state.empty": "まだ何もありません",
  "state.readOnly": "閲覧のみ",
  "action.approve": "承認",
  "action.reject": "却下",
  "action.save": "保存",
  "action.saving": "保存中…",
  "action.saved": "保存しました",
  "action.cancel": "キャンセル",
  "action.export": "Excel にエクスポート",
};
export default ja;
